export default () => ({
  toggleFieldContainer: { display: 'flex' },
  toggleFieldLabelContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  toggleFieldLabel: {
    lineHeight: '48px',
    marginRight: 4,
  },
  defaultDueDateTimeInput: {
    width: 145,
    margin: 6,
  },
  formControl: { marginBottom: '2rem' },
  dueDateWorkingTimeFormControl: { marginLeft: 6 },
  card: { width: '100%' },
});
